export const DE = {
  AactivityOnboarding: {
    SUMMARY: {
      ACTIVITY_TEXT: 'Häufigkeit des Auslaufs'
    }
  },
  HipayPayments: {
    CARDNUMBER: 'Kartennummer',
    EXPIRYDATE: 'Ablaufdatum',
    FULLNAME: 'Vollständiger Name',
    GOCARDLESS_LINK: 'Durch Bankeinzug zahlen'
  },
  Slider: {
    GPS_INTERVAL: 'GPS-Zeitintervall'
  },
  TypeSwitch: {
    ANIMAL_SUBTITLE: 'Wählen Sie das Tier, für das Sie diesen Tracker gekauft haben:',
    CAT_TYPE: 'Katzentracker',
    DOG_TYPE: 'Hundetracker',
    FAMILY_SUBTITLE: 'Für wen haben Sie den Tracker gekauft?',
    KID_TYPE: 'Ein Kind',
    SILVER_TYPE: 'Ein Senior',
    TITLE: 'Welche Art von Tracker ist Ihr Tracker?'
  },
  account: {
    LANGUAGE: {
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten.',
        UPDATE_SUCCESS: 'Sprache erfolgreich aktualisiert'
      }
    },
    NAV: {
      LANGUAGE: 'Sprache',
      PASSWORD: 'Passwort',
      PAYMENTS: 'Rechnungsstellung',
      USER_PREFERENCES: 'Voreinstellungen',
      USER_PROFILE: 'Benutzerprofil'
    },
    PASSWORD: {
      HEADLINE: 'Passwortänderung',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten.',
        UPDATE_ERROR_WRONG_PASSWORD: 'Sie haben ein falsches altes Passwort eingegeben.',
        UPDATE_SUCCESS: 'Das Passwort wurde geändert.'
      }
    },
    PAYMENTS: {
      HISTORY_HEADLINE: 'Zahlungsverlauf',
      MAIN_HEADLINE: 'Rechnungsstellung'
    },
    USER_PREFERENCES: {
      EMAIL_PREFERENCES_HEADLINE: 'E-Mail-Voreinstellungen',
      EMAIL_PREFERENCES_USER_INFO: 'Die Einstellungen werden auf die E-Mail-Adresse angewendet {{user_email}}',
      MAIN_HEADLINE: 'Voreinstellungen',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Beim Speichern der Voreinstellungen ist ein Problem aufgetreten.',
        UPDATE_SUCCESS: 'Voreinstellungen wurden erfolgreich aktualisiert.'
      },
      METRIC_PREFERENCES_DESCRIPTION: 'Wählen Sie die für Ihren Tracker verwendete Entfernungseinheit.',
      METRIC_PREFERENCES_HEADLINE: 'Präferenz für das metrische System :'
    },
    USER_PROFILE: {
      BASIC_INFO_HEADLINE: 'Basisinformationen',
      BILLING_HEADLINE: 'Rechnungsadresse',
      MAIN_HEADLINE: 'Benutzerprofil',
      MARKETING_AGREEMENT_TEXT: 'Ich bin damit einverstanden, Angebote und Werbeaktionen von Weenect-Partnern zu erhalten.',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten.',
        UPDATE_SUCCESS: 'Daten erfolgreich aktualisiert'
      },
      METRIC_KM: 'Kilometer',
      METRIC_MILES: 'Meilen',
      PREFERRED_METRIC: 'Zu verwendende Maβeinheit:'
    }
  },
  activity: {
    AVERAGE_SPEED: 'Mittlere Geschwindigkeit',
    CONTROLS: {
      PAUSE_PLAYING_TITLE: 'Verlaufs Video anhalten',
      RESUME_PLAYING_TITLE: 'Verlaufs Video erneut abspielen',
      START_PLAYING: 'Wiedergabe',
      START_PLAYING_TITLE: 'Verlaufs Video abspielen',
      STOP_PLAYING: 'Stop',
      STOP_PLAYING_TITLE: 'Verlaufs Video anhalten',
      TOGGLE_HEATMAP: 'Thermokarte',
      TOGGLE_HEATMAP_TITLE: 'Thermokarte anzeigen',
      TOGGLE_PATH: 'Standortverlauf',
      TOGGLE_PATH_TITLE: 'Standortverlauf anzeigen'
    },
    DETAIL_TITLE: 'Aktivitätendetails',
    EMPTY_LIST: 'Keine Benachrichtigungen vorhanden. Ändern Sie den ausgewählten Zeitraum oder überprüfen Sie, dass der Tracker richtig eingeschaltet ist.',
    EVENTS: {
      ALERT: 'Seitentaste betätigt',
      BATTERY: 'Akku schwach – {{battery}}% verbleiben',
      CALL_END: 'SOS-Anruf beendet',
      CALL_REQ: 'SOS-Anruf angefordert',
      ENTERS_GEOFENCE: 'Eintritt in die Zone',
      EXIT_GEOFENCE: 'Verlassen der Zone',
      FLASH_REQ: 'Blitz gefragt',
      FREQ_CHANGE: 'Das Zeitintervall wurde geändert.',
      RING: 'Klingeln durchgeführt',
      RING_REQ: 'Klingelanfrage gesendet',
      SOS: 'SOS-Alarm',
      TRACKER_OFF: 'Tracker ausgeschaltet',
      TRACKER_ON: 'Tracker eingeschaltet',
      VIBRATE: 'Vibration durchgeführt',
      VIBRATE_REQ: 'Vibrationsanfrage gesendet'
    },
    FEEDBACKTEXT: {
      FIRST: '',
      SECOND: ''
    },
    HISTORY_TITLE: 'Benachrichtigungsverlauf',
    LAST_TIME_PERIOD: 'Letzte (...) anzeigen',
    LOADING: 'Wird geladen ...',
    MAXIMUM_SPEED: 'Maximale Geschwindigkeit',
    OBJECTIVE: {
      CONTENT: 'Legen Sie tägliche Ziele fest, die Sie erreichen wollen, um sicherzustellen, dass Ihr Tier gesund bleibt.',
      DAILY_REACHED: '{{name}} hat ihr Tagesziel erreicht!',
      HELPTEXT: 'Wie viel Bewegung braucht mein Haustier?',
      RECOMENDED_VALUE: 'Empfohlen: 1 stunde',
      SUBTEXT: 'Legen Sie die zu erreichende tägliche Aktivitätszeit fest :',
      TITLE: 'Verwaltung von Zielen'
    },
    ONBOARDING: {
      FIRST_SUBTEXT: 'Dieses Tool wird Ihnen helfen, die tägliche Aktivität Ihres Vierbeiners zu erfassen. ',
      SECOND_SUBTEXT: 'Wie lange hat er geschlafen? Wie viele Schritte hat er heute gemacht?',
      START: 'Beginnen',
      THIRD_SUBTEXT: 'Sie können sich sogar ein Ziel für die Rasse Ihres Haustiers setzen, damit es die tägliche Aktivität bekommt, die es braucht.',
      TITLE: 'Willkommen bei der Weenect-Aktivitätsüberwachung!'
    },
    PROGRESSBAR: {
      TITLE: 'Zeit der Aktivität'
    },
    SELECT_DAY: 'Einen Tag auswählen',
    SELECT_TIME: 'Benutzen Sie ihre Maus, um den Zeitraum auszuwählen, der angezeigt werden soll',
    SUMMARY: {
      ACTIVITY: 'Aktivität',
      AWAKENING: 'Wachheit',
      DATEINTERVAL: '',
      DAY_INDEX: 't',
      DISTRIBUTIONTEXT: 'Einteilung der Aktivität',
      HOUR_INDEX: 's',
      LASTWEEK: '',
      MENU_TITLE: 'Tätigkeitsbericht',
      MIN_INDEX: 'min',
      PREVIOUS_DAY: '',
      PREVIOUS_MONTH: '',
      PREVIOUS_WEEK: '',
      REPORT: 'Bericht anzeigen ',
      REST: 'Ausruhen',
      SUBTEXT: '{{name}} hat noch eine {{period}} Zeit, um sich zu bewegen. Wie wäre es, wenn Sie mit ihr einen Spaziergang machen würden? ',
      TEXT_OBJECTIVE_COMPLETED: '{{name}} hat ihr Tagesziel erreicht!',
      TEXT_OBJECTIVE_COMPLETED_TREAT: 'Herzlichen Glückwunsch, {{name}} hat ihr Ziel erreicht! Vielleicht verdient sie ein kleines Leckerli?',
      TEXT_OBJECTIVE_NONE: '{{name}} hat noch keine Daten für diesen Zeitraum.',
      TEXT_OBJECTIVE_NONE_VERIFY_TRACKER: '{{name}} hat noch keine Bewegungen aufgezeichnet. Vergewissern Sie sich, dass Ihr Tracker eingeschaltet und der Akku geladen ist!',
      TITTLE: '{{name}} Fortschritte',
      TODAY: 'Heute,',
      YESTERDAY: 'gestern'
    },
    TIME_ELAPSED: 'Dauer',
    TOTAL_DISTANCE: 'Gesamtentfernung'
  },
  activityGeneral: {
    BEHAVIOR: 'Aktivität',
    STANDARD_MORPHOLOGY: 'Morphologie ',
    STERILIZED: 'Sterilisiert'
  },
  activityOnboarding: {
    COMMON: {
      STEP: 'Schritt',
      TRACKER_PROFIL: 'Tracker profile'
    },
    MONTH: {
      APRIL: 'April',
      AUGUST: 'August',
      DECEMBER: 'Dezember',
      FEBRUARY: 'Februar',
      JANUARY: 'Januar',
      JULY: 'Juli',
      JUNE: 'Juni',
      MARCH: 'März',
      MAY: 'Mai',
      NOVEMBER: 'November',
      OCTOBER: 'Oktober',
      SEPTEMBER: 'September'
    },
    PET_ACTIVITY: {
      FIRST_BUTTON: 'Inaktiv (minimale Aktivität)',
      FIRST_BUTTON_CAT: 'Ausnahmsweise (Urlaub, unvorhergesehene Ereignisse...)',
      FIRST_BUTTON_DOG: 'Nur für ihre Bedürfnisse',
      FOURTH_BUTTON: 'Sehr aktiv (zwei bis drei Spaziergänge pro Tag)',
      FOURTH_BUTTON_CAT: 'Regelmäßig, sowohl tagsüber als auch nachts',
      FOURTH_BUTTON_DOG: '2 bis 3 Spaziergänge/Tag',
      SECOND_BUTTON: 'Normal (zwei bis drei Spaziergänge pro Woche)',
      SECOND_BUTTON_CAT: 'Gelegentlich, auf eigenen Wunsch\n',
      SECOND_BUTTON_DOG: '2 bis 3 Spaziergänge pro Woche',
      SELECT_ACTIVITY: 'Wie oft geht es nach draußen?',
      THIRD_BUTTON: 'Aktiv (ein Spaziergang pro Tag)',
      THIRD_BUTTON_CAT: 'Regelmäßig, tagsüber',
      THIRD_BUTTON_DOG: 'Ein Spaziergang pro Tag',
      TITLE: 'Wie würden Sie das sportliche Profil Ihres Tieres beschreiben?'
    },
    PET_AGE: {
      FIRST_COMMON_TEXT: 'Jahr(e) und ',
      SECOND_COMMON_TEXT: 'Monat(e)',
      TITLE: 'Wie lautet das Geburtsdatum?'
    },
    PET_GENDER: {
      FEMALE: 'Weiblich',
      FIRST_TITLE: 'Ist Ihr Haustier weiblich oder männlich?',
      MALE: 'Männlich',
      SECOND_TITLE: 'Ist Ihr Haustier sterilisiert?'
    },
    PET_HEALTH: {
      LAST_VACINATION: 'Wie war seine letzte Impfung?',
      LAST_VET_VISIT: 'Wann war er zuletzt beim Tierarzt?',
      TITLE: 'Gesundheitspunkt'
    },
    PET_IDENTIFICATION: {
      CHIP: 'Gechippt',
      NONE: 'Mein Tier ist nicht gekennzeichnet',
      SELECT_IDENTIFICATION: 'Wie wird er identifiziert?',
      TATTOO: 'Tätowiert'
    },
    PET_INFO: {
      GET_STARTED: 'Los geht\'s!',
      NEED_TO_KNOW: 'Es ist wichtig für uns, dass wir  {{name}} kennenlernen.',
      PETS_DETAILS: 'Füllen Sie die Informationen über Ihr Haustier aus!',
      PETS_GENDER: {
        MIXED_BREED: 'Er ist ein Mischling'
      },
      PET_GENDER_COMMON: 'Zu Beginn ist Ihr Haustier: ',
      SECOND_PETS_DETAILS: 'Füllen Sie die Daten Ihres Haustiers aus'
    },
    PET_MORPH: {
      AVERAGE: 'Normal',
      COMMON_TEXT: 'Circa',
      FIRST_TITLE: 'Wie würden Sie den Körperbau Ihres Tieres beschreiben?',
      HELP_TEXT: 'Wie kann ich den Körperbau meines Tieres bestimmen?\n',
      LEAN: 'Mager',
      OBESE: 'Übergewichtig',
      OVERWEIGHT: 'Übergewichtig',
      SECOND_TITLE: 'Wie viel wiegt Ihr Tier?',
      WEIGH_TEXT: 'Wie viel wiegt Ihr Tier?\n'
    },
    PET_NAME: {
      COMMON_TEXT: 'Zunächst möchten wir Ihr Haustier gern kennenlernen.\u2028 Anschließend können Sie diese Angaben in den Einstellungen ändern. ',
      PLACEHOLDER: 'Name Ihres Tieres',
      TITLE: 'Wie heißt er/sie?'
    },
    PET_RACE: {
      COMMON_TEXT: 'Rasse unbekannt',
      PLACEHOLDER: 'Rasse Ihres Hundes',
      SELECT_BREED: 'Wählen Sie die Rasse aus',
      TITLE: 'Welcher Rasse gehört Ihr Tier an?'
    },
    PET_TYPE: {
      CAT: 'Eine Katze',
      DOG: 'Ein Hund'
    },
    SUMMARY: {
      BIRTH_DATE: 'Geburtsdatum',
      BREED: 'Rasse',
      CONDITION: 'Zustand',
      DAILY_EXERCISE: 'Tägliche Bewegung',
      DELETE: 'Das Profil zurücksetzen.',
      HEALTH: 'Gesundheit',
      IDENTIFICATION: 'Kennzeichnung',
      MODAL: {
        NO: 'No, cancel',
        SUBTEXT: 'Dann müssen Sie den Vorgang noch einmal von vorne beginnen.',
        TITLE: 'Sind Sie sicher, dass Sie die Informationen Ihres Haustiers zurücksetzen möchten?',
        YES: 'Ja, ich bin sicher'
      },
      MORPHOLOGY: 'Körperbau',
      NAME: 'Namen',
      RECAPTEXT: 'Hier sind die Informationen über Ihren Begleiter.',
      SEX: 'Geschlecht',
      SPECIES: 'Spezies',
      SUBMIT: 'Profil bestätigen',
      UNSPECIFIED: 'felder',
      VALIDATION: 'Validierung des Profils',
      VALIDATION_TEXT: 'Bitte bestätigen Sie Ihre Angaben, bevor Sie fortfahren. ',
      WEIGHT: 'Gewicht'
    }
  },
  activityTracking: {
    ACTIVITY: 'Aktivitätspunkte',
    DAILY_CHART: 'Aktivitätsdiagramm',
    DAYS: 'tag',
    HOURS: 'Stunden',
    INTERVAL: {
      TEXT: 'Verschieben Sie die Ränder der Grafik, um das zu analysierende Zeitintervall einzustellen.',
      TITLE: 'Zeitintervall auswählen'
    },
    MIN: 'minuten',
    PERIOD: {
      DAY: 'Tag',
      MONTH: 'Monat',
      TITLE: 'Zeitraum auswählen',
      WEEK: 'Woche',
      YEAR: 'Jahr'
    },
    TEXT: 'Anhand dieser Grafik können Sie die Aktivität Ihres Tieres verfolgen. Die Messung dieser Aktivität erfolgt über ein Intervall, das bei 0 beginnt und keine Höchstgrenze hat. Jeder Aktivitätspunkt steht für eine Beschleunigung, das heißt: für eine Bewegung, die Ihr Tier ausführt.'
  },
  alertCustomer: {
    BODY0: 'unser SIM-Kartenanbieter wartet seine Systeme derzeit.',
    BODY1: '<1>Während dieser Wartung wird die Aktivierungszeit der SIM-Karte auf 24 Stunden verlängert</1>.',
    BODY2: 'Wir entschuldigen uns für die daraus entstehenden Unannehmlichkeiten und für diese Situation, auf die wir leider keinen Einfluss haben.\n\nFür weitere Informationen können Sie unseren Support unter <1>family@weenect.com</1> oder telefonisch unter +49.32.212.29.33.36  kontaktieren.',
    FOOTER: 'Das Weenect Team'
  },
  changePaymentMean: {
    ADD_BANK_ACCOUNT: 'Hinzufügen eines zu belastenden Kontos',
    ADD_BANK_CARD: 'Zur Zahlung per Kreditkarte wechseln',
    BANK_ACCOUNT_ERROR: 'Bei der Änderung Ihrer Bankverbindung ist ein Fehler aufgetreten. Bitte wenden Sie sich an unseren Kundenservice.',
    BANK_ACCOUNT_EXPLANATION: 'Wir weisen Sie darauf hin, dass Ihre Bankdaten von unseren Servern nicht gespeichert werden.',
    BANK_ACCOUNT_SUCCESS: 'Bankverbindung aktualisiert',
    BANK_CARD_ERRORED: 'Problem bei der Änderung der Zahlungsmethode. Bitte wenden Sie sich an unseren <1>Kundenservice</1>.',
    BANK_CARD_UPDATED: 'Kreditkarte aktualisiert',
    CAPTATION: 'Für die Aktualisierung Ihrer Bankinformationen autorisieren wir auf Ihrer Karte eine Gebühr von {{ amount }}.',
    CAPTATION_EXPLANATION1: 'Diese Summe wird nicht abgebucht. Die Transaktion wird automatisch storniert.',
    CAPTATION_EXPLANATION2: 'Dieses Verfahren ermöglicht uns, die Zahlungsstandards des Internets einzuhalten und die Sicherheit Ihrer Bankverbindung zu gewährleisten. Diese Informationen werden nicht über unsere Server geleitet.',
    CAPTATION_EXPLANATION3: 'ACHTUNG: Das Abbuchungsformular trägt den Namen "Hareau" und nicht "Weenect". Das ist normal, es ist der Name unseres Unternehmens. "Weenect" ist unser Markenname.',
    CAPTATION_EXPLANATION4: 'Ändern Sie Ihre Bankverbindung unter Beibehaltung desselben Abonnements.',
    CARD_AUTHORIZED: 'Die zulässigen Zahlungsmittel sind:',
    CHANGE_PAYMENT_MEAN: 'Meine Kreditkarte aktualisieren',
    CURRENT_CHOICE_CB: 'Sie haben sich für die Zahlung per Kreditkarte entschieden.',
    CURRENT_CHOICE_IBAN: 'Sie haben sich für die Zahlung per IBAN entschieden',
    CURRENT_MEAN: 'Aktuelle Zahlungsmethode',
    CURRENT_MEAN_PHRASE: 'Sie haben sich für die Zahlung per Kreditkarte entschieden',
    CURRENT_MEAN_PHRASE_GOCARDLESS: 'Sie haben sich für die Zahlung per Bankeinzug entschieden ',
    DEFAULT_MEAN: 'Art der Standardzahlung:',
    GO_TO_SEPA: 'Zum Lastschriftverfahren wechseln',
    MODIFY: 'Mein Zahlungsmittel ändern',
    TITLE: 'Zahlungsmittel',
    UPDATE_BANK_ACCOUNT: 'Meine IBAN aktualisieren',
    UPDATE_BANK_CARD: 'Meine Kreditkarte aktualisieren',
    USED_PAYMENT_EXPLANATION: 'Diese Zahlungsmethode wird verwendet, um Ihre Abonnements und Optionen zu bezahlen.'
  },
  commonActions: {
    ACTIVATE: 'Aktivieren',
    BACK: 'Zurück',
    CANCEL: 'Abbrechen',
    CAN_BE_CANCELED: 'Eine Kündigung ist jederzeit möglich.',
    CHANGE: 'Speichern',
    CONFIGURE: 'Konfigurieren',
    DEACTIVATE: '',
    GO_MAP: 'Zur Karte',
    MESSAGES: {
      UPDATE_ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten.'
    },
    NEXT: 'Weiter',
    NO: 'Nein',
    OK: 'O. K.',
    REGISTER: 'Aktivieren',
    SAVE: 'Speichern',
    SELECT_ALL: 'Alles auswählen',
    SEND: 'Senden',
    SUBSCRIBE: 'Abonnieren',
    THEN: 'dann',
    UNSELECT_ALL: 'Alles abwählen',
    UPDATE: 'Speichern',
    VALIDATE: 'Bestätigen',
    YES: 'Ja'
  },
  creditCardAlert: {
    AUTO_RENEWAL_ADVICE: 'Ihr Konto bleibt weiterhin aktiv, aber bitte aktualisieren Sie Ihre Zahlungsmethoden, damit Ihre Abo-Verlängerung reibungslos abläuft.',
    AUTO_RENEWAL_NOTICE: '<1>Achtung!</1> Ihr Abonnement läuft ab und Ihre Kreditkarte ist abgelaufen.'
  },
  emailPreferences: {
    EMAIL_LISTS: {
      COMPANY_NEWS: 'Neuigkeiten aus dem Unternehmen',
      NEW_FEATURES: 'Neue Funktionen',
      OFFERS: 'Werbeangebote',
      SERVICE_STATUS: 'Störungen des Dienstes und Updates',
      SURVEYS_AND_TESTS: 'Umfragen und Betatests',
      TUTORIALS: 'Tutorials'
    },
    EMAIL_LISTS_HEADER: 'Liste der E-Mails',
    EMAIL_LISTS_INFO: {
      SERVICE_STATUS: 'Für den reibungslosen Betrieb des Dienstes erforderlich.'
    },
    LANGUAGE_PREFERENCES_DESCRIPTION: 'Wählen Sie die Sprache, in der Sie die E-Mails erhalten möchten :',
    PREFERENCES_DECRIPTION: 'Wählen Sie die Art der E-Mails, die Sie erhalten möchten. Wir werden Ihnen nur diejenigen schicken, die Ihren Einstellungen entsprechen. '
  },
  error: {
    TITLE: 'Es ist ein Problem aufgetreten '
  },
  errors: {
    DEFAULT: 'Feld ungültig',
    FIELD_REQUIRED: 'Dies ist ein Pflichtfeld.',
    GENERAL: 'Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.',
    IMEI: 'Geben Sie eine gültige IMEI-Nummer an.',
    MAIL_FORMAT: 'Die Form der E-Mail-Adresse ist ungültig.',
    MAX_LENGTH: 'Das Feld darf höchstens ${max} Zeichen enthalten.',
    PASSWORD_FORMAT: 'Ihr Passwort muss mindestens eine Ziffer, einen Großbuchstaben, und einen Kleinbuchstaben enthalten.',
    PHONE_FORMAT: 'Die Mobilfunknummer muss die Landesvorwahl enthalten.',
    PROMO_CODE: 'Rabattcode nicht gültig'
  },
  forgotPassword: {
    FORGOT_PASSWORD_BUTTON: 'Link anfordern um ihr Passwort zurückzusetzen',
    FORGOT_PASSWORD_CANCEL: 'Zurück zur Verbindung',
    FORGOT_PASSWORD_ERRORS: {
      UNKNOWN: 'Ein Fehler ist aufgetreten. Bitte nutzen Sie für die Kontaktaufnahme das vorgesehene Formular.'
    },
    FORGOT_PASSWORD_EXPIRED: 'Ihr Passwort-Zurücksetzen-Link ist abgelaufen.',
    FORGOT_PASSWORD_RETRY: 'Link anfordern, um Ihr Passwort zurückzusetzen.',
    FORGOT_PASSWORD_SUCCESS: 'Sollten wir einen Account unter {{mail}} finden können, erhalten Sie eine E-Mail mit einem Link, mit dem Sie Ihr Passwort zurücksetzen können.'
  },
  forms: {
    CITY: {
      LABEL: 'Stadt',
      PLACEHOLDER: 'Ihr Wohnort'
    },
    CONFIRM_PASSWORD: {
      LABEL: 'Passwortbestätigung',
      PLACEHOLDER: 'Bestätigen'
    },
    COUNTRY: {
      LABEL: 'Land'
    },
    EMAIL: {
      LABEL: 'E-Mail-Adresse',
      PLACEHOLDER: 'ihre@email.com'
    },
    FIRST_NAME: {
      LABEL: 'Vorname',
      PLACEHOLDER: 'Ihr Vorname'
    },
    LANGUAGE: {
      LABEL: 'Sprache'
    },
    LAST_NAME: {
      LABEL: 'Nachname',
      PLACEHOLDER: 'Ihr Nachname'
    },
    NEW_PASSWORD: {
      LABEL: 'Neues Passwort',
      PLACEHOLDER: 'Ihr neues Passwort'
    },
    OLD_PASSWORD: {
      LABEL: 'Altes Passwort',
      PLACEHOLDER: 'Ihr altes Passwort'
    },
    PASSWORD: {
      LABEL: 'Passwort',
      PLACEHOLDER: 'Passwort',
      VALIDATION: 'Ihr Passwort muss aus mindestens 8 Zeichen bestehen',
      WARNING: 'Warnung: "qwertzuiopü" und "123456789" sind KEINE sicheren Passwörter.\nTesten Sie die Sicherheit Ihres Passworts hier: <1>https://howsecureismypassword.net</1>'
    },
    PHONE: {
      LABEL: 'Telefon',
      PLACEHOLDER: '+4900000000'
    },
    POSTAL_CODE: {
      LABEL: 'Postleitzahl',
      PLACEHOLDER: 'Ihre Postleitzahl',
      STREET_NUMBER: 'Straße und Hausnummer'
    },
    STREET: {
      LABEL: 'Anschrift',
      PLACEHOLDER: 'Straße und Hausnummer'
    }
  },
  geofences: {
    CREATE: {
      HEADLINE: 'Eine neue Zone erstellen'
    },
    EDIT: {
      DELETE_GEOFENCE: 'Die Zone löschen',
      ENTRANCE_NOTIFICATION: 'In-Zone-Benachrichtigung',
      EXIT_NOTIFICATION: 'Aus-Zone-Benachrichtigung',
      GEOCODE_LABEL: 'Eine Adresse verwenden',
      GEOCODE_PLACEHOLDER: 'Geben Sie hier die Adresse ein.',
      LOCATION: 'Standort des Zentrums der Zone',
      NAME_INPUT: {
        LABEL: 'Name der Zone',
        PLACRHOLDER: 'Den Namen der Zone eingeben'
      },
      OUTDOORS: 'Außenzone (Park, Wald)',
      OUTDOORS_TOOLTIP: 'Da GPS-Tracker im Freien genauer sind, sind die Regeln für die Benachrichtigung einer Ein- oder Ausgangsmeldung in einer Innen- oder Außenzonen unterschiedlich.',
      POINT_ON_THE_MAP_TEXT: 'oder direkt auf der Karte auswählen',
      RADIUS: 'Größe der Zone (Radius)',
      TRACKER_LAST_POSITION_BUTTON: 'Den Standort des Trackers verwenden',
      UNKNOWN_ADDRESS: 'Unbekannte Adresse '
    }
  },
  header: {
    ALL_TRACKERS: 'Alle Tracker',
    AVAILABLE_PLURAL: 'verfügbar',
    NAV: {
      ACCOUNT: 'Konto',
      INSURANCE: 'Versicherung',
      LOGOUT: 'Abmelden',
      SUPPORT: 'Support',
      TRACKERS: 'Karte'
    },
    SEARCHBAR_RESULT: 'Tracker gefunden',
    SEARCHBAR_TITLE: 'Einen Tracker suchen:',
    TRACKERS: 'Tracker',
    WHITE_LABEL: {
      IN_PARTERNSHIP_WITH: 'In Partnerschaft mit'
    }
  },
  imeiInfo: {
    HINT: 'Sie finden die IMEI-Nummer auf der Rückseite Ihres Trackers.',
    IMAGE_ALT: 'Foto vom Tracker',
    TITLE: 'IMEI-Nummer'
  },
  login: {
    FORGOT_PASSWORD: 'Passwort vergessen?',
    LOGIN_ERRORS: {
      UNKNOWN: 'Die Anmeldung ist fehlgeschlagen.'
    },
    SIGN_IN_BUTTON: 'Anmelden',
    SIGN_IN_HEADLINE: 'Anmelden',
    SIGN_UP_BUTTON: 'Ein Konto erstellen',
    SIGN_UP_HEADLINE: 'Sie haben noch kein Konto?',
    TERMS_LINK: 'Nutzungsbedingungen',
    TERMS_LINK_URL: 'https://www.weenect.com/common/pdf/en/cgv-weenect.pdf'
  },
  manageSubscription: {
    CANCEL: {
      DESCRIBE_YOUR_PROBLEMS: 'Könnten Sie uns bitte den Grund für Ihre Kündigung verraten?',
      GIVE_US_DETAILS: 'Grund für Ihre Kündigung',
      REASONS: {
        AFTER_SALES_SERVICE: 'Schlechte Erfahrungen mit dem Kundenservice',
        BATTERY: 'Akkulaufzeit nicht ausreichend',
        LOST_BROKEN: 'Ich habe es verloren / kaputtgemacht',
        MOBILE_APPLICATION: 'Die App funktioniert nicht.',
        NOT_SATISFIED: 'Ich bin mit Weenect nicht zufrieden',
        NO_USE: 'Ich brauche es nicht mehr',
        TOO_EXPENSIVE: 'Das Abonnement ist zu teuer',
        TRACKER_FORMAT: 'Format des Trackers verbesserungsbedürftig (Größe und Gewicht)',
        WILL_REACTIVATE_LATER: 'Ich werde das Abo später reaktivieren.'
      },
      SAD_TO_SEE_YOU_LEAVE: 'Wir sind traurig, dass Sie uns verlassen!',
      WHY_DO_YOU_RESIGN: 'Warum möchten Sie Ihr Abo kündigen?'
    },
    CANCEL_EXPIRE: 'Die automatische Verlängerung ist aufgehoben. Das Abo läuft am {{date}} ab.',
    CANCEL_QUESTION: 'Möchten Sie das Abo nicht fortsetzen?',
    CANCEL_RENEWAL: 'Automatische Verlängerung aufheben',
    CANCEL_RENEWAL_BIS: 'Abo kündigen',
    CANT_RESIGN_UNDER_EXTENDED_NOTICE: 'Möchten Sie Ihr Abo kündigen oder nur die automatische Verlängerung Ihres Abos deaktivieren?\nRufen Sie uns an unter +33 (0) 1 87 66 98 71 (montags bis freitags von 9:30 bis 16:00 Uhr).',
    CANT_RESIGN_UNDER_NOTICE: 'Es ist nicht möglich, Ihr Abonnement innerhalb der letzten 30 Tage zu kündigen. Bitte wenden Sie sich an das Kundendienstteam.',
    CANT_RESIGN_UNTIL: 'Sie können Ihr Abo bis zum {{date}} nicht kündigen.',
    CANT_RESIGN_WHILE_COMMITED: 'Sie sind für 3 Monate gebunden, die Kündigung Ihres Abonnements wird erst zum Ende der laufenden Periode wirksam, d.h. am {{date}}',
    CURRENT_PLAN: 'Aktuelles Abo',
    HEADLINE: 'Abo verwalten',
    MESSAGES: {
      UPDATE_SUCCESS: 'Das Abo wurde aktualisiert.'
    },
    RENEW_SUBSCRIPTION: 'Abo verlängern',
    RESIGN_DATE: 'Die Kündigung Ihres Abonnements wird zum Ende des aktuellen Zeitraums wirksam, also zum {{date}}',
    RETURN_TO_TRACKERS: 'Zurück zur Karte'
  },
  map: {
    NO_GPS_MARKER_TITLE: 'Kein GPS-Signal',
    POSITION: 'Position'
  },
  mapControls: {
    MAP_TYPE: 'Kartentyp',
    REFRESH_POSITION: 'Position aktualisieren',
    SUPER_LIVE: 'Super Live',
    ZOOM_IN: 'Zoom +',
    ZOOM_OUT: 'Zoom -'
  },
  mapLayers: {
    CLASSIC_MAPS: 'Klassische Karten',
    DONT_SUBSCRIBE: 'Weiterhin die klassischen Karten benutzen',
    FOREST_PATH: 'Waldwegen und Pfaden',
    GOOGLE_STREET: 'Google Maps',
    GRAY: 'Schwarz-weiß',
    PLAN: 'Planen',
    PREMIUM_MAPS: 'Premium-Karten',
    PREMIUM_SUBSCRIBE: 'Sich für der Premium-Kartenoption abonnieren',
    PREMIUM_WARNING_MSG: 'Achtung! Sie haben für die Premium-Kartenoption noch kein Abonnement.\n\nDank dieser Option können Sie von besonders umfassenden und regelmäßig aktualisierten Karten profitieren und dabei die Nachfolgung Ihres Trackers optimieren. \u2028Mit den Varianten „HD-Satellitenkarte“, „Reliefkarte“ oder „Waldwege“ können Sie Ihren Tracker sofort mit einem Blick orten.\n\nAbonnement für nur {{mapOptionPrice}}/Monat!',
    RELIEF: 'Reliefkarte',
    SATELLITE: 'Satellit',
    STREET: 'Klassisch',
    UNLOCK_MAPS: 'Schalten Sie zusätzliche Karten frei, indem Sie sie anklicken!'
  },
  misc: {
    LANGUAGE: {
      DE: 'Deutsch',
      EN: 'Englisch',
      ES: 'Spanisch',
      FR: 'Französisch',
      IT: 'Italienisch',
      NL: 'Niederländisch'
    },
    NO_DATE: 'Kein bekannter Standort',
    ROTATE_DEVICE: 'Weenect ist für die Verwendung im Hochformat bestimmt. Bitte drehen Sie Ihr Gerät, um unsere Dienste optimal nutzen zu können. ',
    locale: 'de-DE'
  },
  onboarding: {
    ACTIVATING_HINT: 'Durchschnittliche Aktivierungsdauer: 5 Minuten',
    ACTIVATING_INDICATOR: 'Aktivierung läuft',
    GREET: {
      BUTTON: 'Ihr Tracker ist eingeschaltet.',
      COMMON_TEXT: 'Für einen optimalen Start empfehlen wir Ihnen, diesem Tutorial zu folgen. So wird Ihnen die Bedienung Ihres Tracker noch leichter fallen.\n\\In wenigen Schritten wird Ihr Gerät einsatzbereit sein. Bitte befolgen Sie die untenstehenden Anweisungen, um es einzuschalten:',
      MAIN_TITLE: 'WILLKOMMEN IN DER WEENECT FAMILIE!',
      RED_TEXT: 'Der Tracker muss sich im Freien befinden, um eine GPS-Position zu empfangen.'
    },
    MAP_INTERACTIONS: {
      COMMON_TEXT: {
        PET: 'Mit diesen Buttons können Sie Ihren Tracker klingeln (Button oben) oder vibrieren (Button unten) lassen. Diese Features ermöglichen es Ihnen, mit Ihrem Haustier das Rückrufkommando zu trainieren.',
        SILVER: 'Mit diesen Buttons  können Sie Ihren Tracker klingeln (Button oben) oder vibrieren (Button unten) lassen. '
      },
      TITLE: 'Buttons zur Interaktion mit dem Tracker'
    },
    MAP_INTERVAL: {
      COMMON_TEXT: 'Mit diesem Button können Sie auswählen, wie oft Sie eine aktuelle GPS-Position von Ihrem Tracker erhalten möchten. Bitte beachten Sie: Je kürzer das festgelegte Zeitintervall, desto geringer ist auch die Akkulaufzeit des Trackers.',
      TITLE: 'Button zur Festlegung des Zeitintervalls für den Positionsverlauf'
    },
    MAP_OPTIONS: {
      COMMON_TEXT: 'Mit diesen Buttons können Sie festlegen, welcher Kartentyp zur Darstellung verwendet werden soll. Zudem können Sie in die Karte hinein- oder herauszoomen.',
      TITLE: 'Button zur Festlegung der Kartenvariante'
    },
    MAP_UPDATE: {
      COMMON_TEXT: 'Mit diesem Button können Sie die GPS-Position Ihres Trackers aktualisieren (um eine neue Position zu erhalten, muss Ihr Tracker mit dem Server verbunden sein und ein gültiges GPS-Signal empfangen).',
      TITLE: 'Button zur Aktualisierung der GPS-Position'
    },
    MODAL: {
      BUTTON_HINT: 'Halten Sie die Taste 3 Sekunden lang gedrückt, bis der Tracker vibriert.',
      HEADLINE: 'Schalten Sie Ihren Tracker im Freien oder auf einer Fensterbank an.',
      IMAGE_ALT: 'Foto vom Tracker',
      MAP_HINT: 'Wenn der Tracker eingeschaltet ist, zeigt er im Durchschnitt nach 5 Minuten die Karte an.'
    },
    REMOTE_ASSISTANCE: {
      ASSISTANCE: {
        COMMON_TEXT: 'Reagiert niemand innerhalb dieses Zeitraums, so wird der Alarm an die Plattform weitergeleitet.'
      },
      EXPLANATION: 'Dort wird der Anruf entgegengenommen und sich um das Anliegen Ihres Angehörigen gekümmert. Je nach Situation kann der Mitarbeiter dort <1>Familienmitglieder kontaktieren oder den Rettungsdienst verständigen</1>.',
      PRICE: 'Die Option kostet 9,99 € pro Monat und kann jederzeit deaktiviert werden.',
      SOS: {
        COMMON_TEXT: 'Ihr Angehöriger drückt die SOS-Taste auf seinem Tracker.'
      },
      TIME: {
        COMMON_TEXT: 'Sie werden benachrichtigt und haben dann 30 Sekunden Zeit, um auf den Alarm zu reagieren.'
      },
      TITLE: 'Lernen Sie unsere neue Option kennen: die Fernunterstützung',
      USE_CASE: 'Ist diese Option aktiviert, kann der Träger des Trackers mit einer speziellen Plattform verbunden werden, über die täglich und rund um die Uhr Fernunterstützung angeboten wird.'
    },
    SIDE_PAGES: {
      COMMON_TEXT: {
        PET: 'Links finden Sie verschiedene Tabs zur Verwaltung und Verwendung Ihres Trackers. Im Tab Historie können Sie den Positionsverlauf und im Tab Aktivitätsverfolgung den Energieaufwand Ihres Haustiers einsehen. Sicherheitszonen können Sie im Tab Zonen definieren. Im Tab Einstellungen finden Sie Informationen zum Profil Ihres Haustiers und im Tab Abonnement können Sie dieses sowie Ihre Abo-Optionen mit wenigen Klicks verwalten.',
        SILVER: 'Links finden Sie verschiedene Tabs zur Verwaltung und Verwendung Ihres Trackers. Im Tab Historie können Sie den Positionsverlauf Ihres geliebten Menschen einsehen und im Tab Zonen können Sie Sicherheitszonen definieren.\n Die Telefonnummern, die im Falle eines abgesetzten SOS-Alarms angerufen werden sollen, sowie die Nachrichten, die beim Drücken der einzelnen seitlichen Knöpfe gesendet werden sollen, können Sie im Tab Einstellungen festlegen. Ihr Abonnement und Ihre Abo-Optionen können Sie im Tab Abonnement mit wenigen Klicks verwalten.'
      },
      TITLE: 'Zusätzliche Tabs'
    },
    SKIP: 'Tutorial überspringen',
    SUPERLIVE: {
      COMMON_TEXT: 'Mit diesem Button können Sie den "Superlive"-Modus aktivieren: So erhalten Sie fünf Minuten lang alle zehn Sekunden eine aktuelle GPS-Position.',
      TITLE: '"Superlive"-Button'
    },
    TUTORIAL_START: {
      BUTTON: 'Tutorial fortsetzen',
      COMMON_TEXT: 'Sehr gut, Ihr Tracker ist nun einsatzbereit. Lassen Sie uns mit einer kurzen Übersicht über Ihren persönlichen MyWeenect-Bereich fortfahren.'
    },
    WAITING_GPS_POSITION: 'GPS-Position wird gesucht.',
    WAITING_GPS_POSITION_HINT: 'Schalten Sie Ihren Tracker im Freien ein.'
  },
  optionCardExpired: {
    PROPOSAL: 'Bitte aktualisieren Sie Ihre Kreditkarteninformationen, um unseren Service weiterhin nutzen zu können.',
    UPDATE_CARD: 'Jetzt aktualisieren',
    WARNING: '<1>Achtung!</1> Leider können Sie diese Abonnenment-Option nicht wählen, da <1>Ihre Kreditkarte abgelaufen ist</1>.'
  },
  payment: {
    ADD_NEW_PAYMENT_REGULARISE: 'Bitte registrieren Sie eine neue Zahlungsmethode oder regeln Sie Ihre Situation.',
    EXPIRACY_CREDIT_CARD_TEXT: 'Bitte fügen Sie eine neue Zahlungsmethode hinzu, um Ihre Situation zu bereinigen.',
    NO_PAYMENT_MEAN_YET: 'Zurzeit keine Zahlungsmöglichkeiten',
    NO_PAYMENT_YET: 'Derzeit sind keine Zahlungen möglich.',
    UPDATE_PAYMENT_REGULARISE: 'Bitte aktualisieren oder ändern Sie es, um Ihre Situation zu regulieren.',
    WARNING_ERROR: 'Es scheint, dass es ein Problem mit Ihrer Zahlungsmethode gibt.',
    WARNING_EXPIRACY_CREDIT_CARD: 'Attention, your credit card has expired.',
    WARNING_NOT_ENOUGH_FOUNDS: 'Bitte beachten Sie, dass auf Ihrem Konto nicht genügend Guthaben vorhanden ist.'
  },
  payments: {
    CARD: {
      ACCEPTED: '(EC-Karte, VISA, Mastercard, American Express)',
      DESCRIPTION: '30 Tage Zufriedenheitsgarantie oder Geld zurück',
      NAME: 'Kreditkarte'
    },
    STATUS: {
      CANCELED: 'Abgebrochen',
      ERROR: 'Fehlgeschlagen',
      NEW: 'In Bearbeitung',
      PAYMENT_ERROR: 'Zahlung fehlgeschlagen',
      PAYMENT_ERROR_EXPLAIN_TEXT: 'Bei Ihrer Zahlung ist ein Fehler aufgetreten. Bitte versuchen Sie es in Kürze erneut oder wenden Sie sich',
      PAYMENT_RETRY: 'Erneut versuchen',
      PAYMENT_SAV: 'Kundendienst.',
      PAYMENT_SUCCESS: 'Zahlung erfolgreich!',
      PAYMENT_SUCCESS_TEXT: 'Ihre Zahlung ist eingegangen. Sie können nun Ihre Weenect-Erfahrung starten!',
      PAYMENT_SUCCESS_TEXT_APP: 'Ihre Zahlung ist eingegangen.',
      PENDING: 'In Bearbeitung',
      REFUNDED: 'Erstattet',
      SUCCESS: 'Bestätigt'
    },
    TRANSFER: {
      DESCRIPTION: '15 zusätzliche Tage Bedenkzeit, somit eine 30-tägige Geld-zurück-Garantie bei Nichtzufriedenheit.',
      NAME: 'Bankeinzug'
    }
  },
  periods: {
    ALT: {
      MONTH: '1 Monat',
      YEAR: '1 Jahr',
      YEAR_plural: '{{count}} Jahre'
    },
    BASE: {
      MONTH: 'Monate',
      YEAR: 'Jahr'
    }
  },
  registerSummaryTable: {
    BILLED_MONTH: 'Die Zahlung erfolgt monatlich',
    BILLED_NOW: 'Sofortige Rechnungsstellung',
    BILLED_THREE_YEARS: 'Die Zahlung erfolgt alle drei Jahre',
    BILLED_TWO_YEARS: 'Wird alle zwei Jahre in Rechnung gestellt',
    BILLED_YEAR: 'Die Zahlung erfolgt jährlich',
    HINT_OPTIONS_PRICE: 'Die Optionen in Höhe von {{amount}} werden innerhalb von zwei Stunden getrennt vom Abo in Rechnung gestellt.',
    OPTION_UPGRADE: 'Die Option {{name}} hinzufügen – für nur {{price}} / {{period}}',
    PAY_HINT: 'Klicken Sie auf den Knopf „Zahlen und aktivieren“ und bezahlen Sie {{subscriptionPrice}} für das Abo.',
    SUBSCRIPTION_UPGRADE: 'Wechseln Sie zu einem 2-Jahresabo und sparen Sie jedes Jahr {{amount}}.',
    TOTAL: 'Gesamtpreis'
  },
  registerTracker: {
    BUY_LINK: 'Sie haben noch keinen Weenect-Tracker? <1>Hier können Sie einen kaufen.</1>',
    ERRORS: {
      UNKNOWN: 'Beim Aktivieren Ihres Trackers ist ein Problem aufgetreten, bitte versuchen Sie es erneut.'
    },
    HEADLINE: 'Einen neuen Tracker aktivieren',
    IMEI_INPUT: {
      LABEL: 'IMEI-Nummer',
      PLACEHOLDER: 'Sie finden die IMEI-Nummer auf der Rückseite Ihres Trackers.'
    },
    NAME_INPUT: {
      LABEL: 'Name des Trackers',
      PLACEHOLDER: 'Name der Person, die den Tracker trägt'
    }
  },
  remoteAssistance: {
    BASE: 'Support',
    FEATURES: 'Falls nach einem Drücken der SOS-Taste nicht binnen 30 Sekunden eine Antwort von Ihnen kommt, werden der SOS-Alarm und der Sprachanruf automatisch an unseren Fernsupport übermittelt, täglich und rund um die Uhr. Unsere Mitarbeiter sind befugt, Notdienste wie Polizei oder Rettungsdienst zu verständigen.',
    FORM: {
      ADDRESS_INPUT: {
        LABEL: 'Anschrift',
        PLACEHOLDER: 'Straße und Hausnummer'
      },
      BACK: 'Abbrechen',
      CITY_INPUT: {
        LABEL: 'Stadt',
        PLACEHOLDER: ''
      },
      EXTRA_PHONE: {
        LABEL: 'Zweittelefonnummer (optional)',
        PLACEHOLDER: ''
      },
      HEADLINE: 'Registrierung für den Support',
      NAME_INPUT: {
        LABEL: 'Vollständiger Name',
        PLACEHOLDER: 'Vorname NAME'
      },
      PHONE: {
        LABEL: 'Telefon',
        PLACEHOLDER: ''
      },
      POSTAL_CODE_INPUT: {
        LABEL: 'Postleitzahl',
        PLACEHOLDER: ''
      },
      SAVE: 'Bestätigen',
      TERMS: 'Ich habe die <1>Nutzungsbedingungen</1> für den Dienst gelesen und akzeptiere sie.',
      TEXT: 'Geben Sie die Daten Ihres Angehörigen (der Person, die den Tracker trägt) ein. Anhand der Daten können unsere Mitarbeiter ihm/ihr bei einem SOS-Alarm zu Hilfe kommen.'
    },
    PENDING: {
      WAITING_FOR_CALL_TEST: 'Das Registrierungsformular ist bestätigt. Warte auf den Testanruf.\nSie müssen nun einen Testanruf tätigen, um die Option zu aktivieren. Entnehmen Sie die weitere Vorgehensweise bitte der E-Mail, die Ihnen gesendet wurde.',
      WAITING_FOR_RESIGN: 'Deaktivierung der aktuellen Option.\nWir haben Ihre Anfrage zur Deaktivierung der Option erhalten. Unsere Mitarbeiter kümmern sich jetzt um die Verwaltungsformalitäten. Die Deaktivierung erfolgt in Kürze.',
      WAITING_FOR_VALIDATION: 'Das Registrierungsformular wird jetzt geprüft. \nUnsere Mitarbeiter prüfen jetzt die Angaben, die Sie bei der Anmeldung für die Option gemacht haben. Sobald diese Prüfung abgeschlossen ist, kommen wir zum letzten Schritt vor der Aktivierung der Option: Es wird ein Testanruf getätigt, um zu prüfen, ob alles richtig funktioniert.'
    },
    USER_PHONE: {
      TEXT: 'Tragen Sie Ihre Angaben ein. Anhand der Angaben können unsere Mitarbeiter Sie bei einem SOS-Alarm verständigen.'
    }
  },
  signup: {
    ALREADY_MEMBER_TEXT: 'Sie haben schon ein Konto?',
    CREATE_ACCOUNT_HEADLINE: 'Ein Konto erstellen',
    LOGIN_TEXT: 'Mich einloggen',
    MARKETING_AGREEMENT_TEXT: 'Ich bin damit einverstanden, Angebote und Werbeaktionen von Weenect-Partnern zu erhalten.',
    RETRY: 'Erneut versuchen',
    SIGNUP_ERRORS: {
      EMAIL_ALREADY_EXISTS: 'Diese E-Mail-Adresse ist bereits mit einem Konto verbunden',
      POPIN_EMAIL_ALREADY_EXIST: 'Hoppla, diese E-Mail-Adresse scheint bereits in Gebrauch zu sein.',
      UNKNOWN: 'Die Anmeldung ist fehlgeschlagen, bitte versuchen Sie es erneut.'
    },
    SIGN_IN_TEXT: 'Anmelden',
    SUBMIT_BUTTON: 'Mein Konto erstellen',
    TERMS_AGREEMENT_TEXT: 'Ich akzeptiere <1>die Nutzungsbedingungen</1> für den Dienst.'
  },
  simInfo: {
    TITLE: 'SIM-Nummer'
  },
  subOptions: {
    CANCEL: {
      EXPIRATION_DATE: 'Diese Option wird bis zum {{Datum}} aktiv bleiben.',
      HEADLINE: 'Möchten Sie die Option {{option}} kündigen?'
    },
    MAP: {
      BASE: 'Multi-Karten Paket',
      FEATURES: 'Profitieren Sie von umfassenderem Kartenmaterial und regelmäßigen Karten-Aktualisierungen, um die Bewegungen Ihres Trackers noch genauer zu verfolgen. (HD-Satellitenkarte, Reliefkarte, Waldwege)',
      TITLE: 'HD-Karten: '
    },
    PREMIUM: {
      BASE: 'Premium-Paket',
      BUTTON: {
        FREEMONTH: '1 Monat lang kostenlos testen!'
      },
      DEACTIVATE: 'Wenn Sie diese Option deaktivieren, verlieren Sie Ihre Premiumvorteile.',
      FEATURE: {
        CHAT: {
          BASE: 'Online-Chat',
          TEXT: 'Chatten Sie direkt mit einem Weenect-Berater live in Ihrer App, 7 Tage die Woche, von 9 bis 18 Uhr.',
          TEXT2: 'Nutzen Sie exklusive Vorteile (Online-Chat, SMS-Benachrichtigungen, HD-Karten) innerhalb der App.'
        },
        SMS: {
          TEXT: 'Lassen Sie sich direkt per SMS über alle Benachrichtigungen Ihrer Wahl benachrichtigen (40 SMS pro Monat).'
        }
      },
      FREEMONTH: {
        BASE: 'Erster Monat geschenkt!',
        BASE2: 'GESCHENKT'
      },
      SUBTITLE: 'Das Premium-Paket enthält die folgenden Features:',
      SUB_LEGAL: 'Diese Mitgliedschaft wird automatisch jeden Monat erneuert, über die Zahlungsmethode, die Sie beim Abschluss Ihres Abonnements gewählt haben. Sie können die Mitgliedschaft jederzeit über Ihren persönlichen Bereich kündigen.',
      TEXT_INFO_PRICE: 'Nach dem ersten Monat wird der Dienst mit {{price}}/Monat berechnet.',
      TITLE_DISCOVER: 'Entdecken Sie Ihre exklusiven Vorteile : ',
      TITLE_POPUP: 'Werden Sie ein Premium-Mitglied!'
    },
    SMS_PACK: {
      ALT_FEATURES: 'Erhalten Sie alle Benachrichtigungen per SMS.',
      BASE: 'SMS-Paket',
      FEATURES: 'Erhalten Sie alle Benachrichtigungen per SMS (20 SMS pro Monat abrufbar). Bitte beachten Sie, dass Sie ohne diese Option Benachrichtigungen über Push-Nachrichten (App) und E-Mails erhalten.'
    },
    UNDEFINED: {
      PAYMENTS: 'Zahlung für die Option'
    },
    WARRANTY: {
      ALT_FEATURES: {
        one: 'Erhalten Sie kostenlos einen neuen Tracker, falls Ihr jetziges Gerät kaputtgeht, verloren oder gestohlen wird.',
        other: 'Zahlung mit Debitkarte, Kündigung jederzeit möglich',
        two: 'Ihr Tracker ersetzt in 48 Stunden im Falle von Verlust, Bruch oder Diebstahl, ohne Bedingungen.'
      },
      BASE: 'Bruch und Verlust Garantie',
      EXPLAINER: 'Die Standardgarantie deckt nur Probleme bei der Fertigung des Trackers ab.',
      FEATURES: 'Sie erhalten einen kostenlosen Ersatz-Tracker bei Defekt, Verlust oder Diebstahl Ihres derzeitigen Trackers; eine entsprechende Nachweispflicht ist nicht erforderlich. Die Standardgarantie deckt nur etwaige Fabrikationsfehler des Trackers ab.'
    }
  },
  subscription: {
    COMMON_TEXT: {
      MONTH: '/ Monat',
      OR: 'Oder '
    },
    FEATURES: {
      APP_ACCESS: 'Unbegrenzter Zugriff auf die App und den Ortungsdienst.',
      REFOUND: '15-tägige Testversion: Zufrieden oder Geld zurück.',
      SAV: 'Kundenservice an 6/7 Tagen verfügbar. \nGarantierte Antwort innerhalb von 24 Stunden.',
      WARRANTY: '24 Monate Herstellergarantie.'
    },
    INFO_CGU: 'Um die Abonnements zu nutzen, müssen Sie eine gültige Bankverbindung eingeben und akzeptieren.',
    INFO_CGU_BUTTON: 'die Allgemeinen Geschäftsbedingungen für die Nutzung des Dienstes.',
    INFO_OPTION: 'Die Zahlung erfolgt monatlich, eine Kündigung ist jederzeit möglich.',
    MONEY_BACK: 'Alle Abonnements werden sofort in Rechnung gestellt, können jedoch innerhalb von 15 Tagen gekündigt werden, wobei der gezahlte Betrag in voller Höhe zurückerstattet wird.',
    PAYMENT_INFO: 'Geld-zurück-Garantie: 15 Tage, um Ihren Tracker auszuprobieren.',
    PAYMENT_SUBHEADLINE: 'Wählen Sie eine Zahlungsmethode, um Ihr Abonnement zu bezahlen und Ihren Tracker zu aktivieren.',
    PAYMENT_TITLE: 'Wählen Sie Ihre Zahlungsmethode aus.',
    PAYMENT_TITLE2: 'Registreer uw betaalmethode',
    PRICE_MONTH_SAVED: 'oder {{price}}/Monat',
    SUMMARY: 'Zusammenfassung'
  },
  subscriptionAlert: {
    ACTIVATE_AUTO_RENEWAL: 'Automatische Verlängerung wieder aktivieren',
    AUTO_RENEWAL_ADVICE: 'Wir empfehlen Ihnen, die automatische Verlängerung zu aktivieren, wenn Sie Ihr Abonnement verlängern möchten.',
    AUTO_RENEWAL_NOTICE: '<1>Achtung!</1> Ihr Abonnement für den {{trackerName}} Tracker läuft aus und die automatische Verlängerung ist deaktiviert.',
    CONTINUE_BUTTON: 'Fortfahren',
    MESSAGES: {
      UPDATE_ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten.',
      UPDATE_SUCCESS: 'Erfolgreich aktualisiert'
    },
    REMIND_LATER: 'Mich später anrufen',
    SUPPORT_TEXT: 'Wenn Sie Fragen haben oder glauben, dass es sich hierbei um einen Fehler handelt, wenden Sie sich bitte an unseren <1>Kundenservice.</1>'
  },
  subscriptionOptionsSelection: {
    CANCEL_WARNING_MODAL_HEADLINE: 'Möchten Sie diese Option wirklich deaktivieren?',
    CANCEL_WARNING_SMS: 'Wenn Sie diese Option deaktivieren, erhalten Sie keine Alarmbenachrichtigungen per SMS.',
    CANCEL_WARNING_WARRANTY: 'Wenn Sie diese Option deaktivieren, verlieren Sie den zusätzlichen Schutz durch die Kombiversicherung.',
    EXPLANATION: 'Die Optionen sind standardmäßig aktiviert, aber Sie können diese durch einfaches Anklicken deaktivieren.',
    EXPLANATION2: 'And cancellation is possible at any time.',
    EXPLANATION3: 'Es werden keine Zahlungen durchgeführt.',
    HINT: 'Sie können jederzeit eine Option aktivieren oder deaktivieren.',
    MAIN_HEADLINE: 'Wählen Sie Ihre Optionen aus.',
    SUBMIT_BUTTON: 'Bestätigen'
  },
  subscriptionPayment: {
    ERRORS: {
      UNKNOWN: 'Während der Zahlung ist ein Problem aufgetreten, bitte versuchen Sie es erneut.'
    },
    GIFT_CARD: {
      EXPLANATION: 'Geben Sie den Code ein, der auf der Rückseite der in Ihrem Tracker enthaltenen Karte geschrieben ist.',
      I_HAVE_ONE: 'Ich habe eine Geschenkkarte',
      NEED_HELP: 'Brauchen Sie Hilfe beim Thema Geschenkkarten?',
      TITLE: 'Nutzen Sie Ihr Geschenk',
      USE: 'Benutzen'
    },
    HEADLINE: 'Zusammenfassung vor der Zahlung',
    PROMOCODE_TEXT: 'Ich habe einen Gutscheincode :',
    PROMO_CODE: 'Promo-Code',
    PROMO_CODE_GIFT_CARD: 'Geschenkkarte',
    SATISFIED_OR_REFUNDED: 'Unsere Garantie: 100% zufrieden oder Geld zurück',
    SATISFIED_OR_REFUNDED_DESCRIPTION: 'Profitieren Sie von einem 30-tägigen, risikofreien Testzeitraum – wenn Sie nicht zufrieden sind, erstatten wir Ihnen Ihr Geld zurück.',
    SELECT_PAYMENT_MEAN: 'Wählen Sie die von Ihnen gewünschte Zahlungsmethode vor dem Bezahlen und Aktivieren Ihres Abonnements aus.',
    SUBMIT_BUTTON: 'Abonnement bezahlen',
    SUBMIT_BUTTON2: 'Den Tracker aktivieren',
    SUMMARY: 'Ihre Auswahl im Überblick'
  },
  subscriptionProcess: {
    GIFT_CARD_EXPLANATION: 'Geben Sie Ihre bevorzugte Zahlungsmethode an, um Ihren Tracker kostenlos zu aktivieren.',
    GIFT_CARD_EXPLANATION2: 'Diese Information ist aus rechtlichen Gründen im Zusammenhang mit der Verwendung von SIM-Karten erforderlich.',
    RETURN_TO_APP: 'Zur Anwendung zurückkehren',
    RETURN_TO_MAP: 'Zur Karte zurückkehren',
    RETURN_TO_TRACKERS: 'Zurück zur Karte',
    STEPS: [
      'Tracker',
      'Abo',
      'Optionen',
      'Zusammenfassung'
    ]
  },
  subscriptionSelection: {
    BEST_OFFER: 'BESTES ANGEBOT',
    CANCELABLE_AFTER_THREE_MONTHS: 'Kündigung nach Ablauf der ersten drei Monate jederzeit möglich',
    CANCEL_ANYTIME: 'Kündigung jederzeit möglich',
    COMMITMENT_TEXT: 'Jederzeit kündbar nach der Mindestbindungsdauer von 3 Monaten.',
    FEATURES: '',
    FEATURES_HEADLINE: 'Alle Abos enthalten:',
    HEADLINE: 'Wählen Sie Ihr Abo aus.',
    MIN_THREE_MONTHS: 'Drei Monate Mindestvertragslaufzeit',
    MONEY_BACK: 'Alle Abos werden sofort in Rechnung gestellt, können aber innerhalb von 30 Tagen widerrufen werden. In diesem Fall wird der gezahlte Betrag vollständig zurückerstattet.',
    PAYMENT_MEANS: 'Zahlung mittels Bankeinzug und Kreditkarte',
    REFUNDED_INFO: 'Wir erstatten das Abonnement bedingungslos zurück.',
    REFUNDED_TEXT: '30 Tage Probezeit: zufrieden oder Geld zurück.',
    SIM_CARD_WARNING: 'Eine SIM-Karte ist bereits fest in Ihren Tracker integriert. Dies erklärt, warum das Abschließen eines Abonnements notwendig ist (zur Deckung der anfallenden Nutzungsgebühren nämlich).',
    SUBMIT_BUTTON: 'Bestätigen',
    XMAS_OFFER: {
      BODY: 'Wir sind jedoch verpflichtet, Sie jetzt zu veranlassen, Ihr zukünftiges Abonnement zu wählen (aus Sicherheitsgründen, denn das Produkt ist mit einer SIM-Karte ausgestattet). Sie werden nicht vor Ablauf der 6 gratis Monate belastet und können dieses Abonnement jederzeit bis zu einem Monat vor dem Datum des Inkrafttretens kündigen.',
      TITLE: 'Ihr Tracker hat 6 Monate Abo vorausbezahlt.'
    },
    features: [
      '30 Tage Zufriedenheitsgarantie',
      'Uneingeschränkte GPS-Ortung',
      'Push-Benachrichtigungen (App) und E-Mail-Benachrichtigungen',
      '10 Minuten Sprachanruf-Guthaben pro Monat'
    ]
  },
  subscriptions: {
    BASE: 'Abo',
    CANCEL_MODAL: {
      HEADLINE: 'Möchten Sie die automatische Verlängerung Ihres Abos aufheben?',
      HINT: 'Ihr Abo bleibt bis zum {{date}} gültig, wird jedoch nicht automatisch verlängert. Nach diesem Datum werden Sie Ihren Tracker nicht mehr orten können.'
    },
    CHANGE_PLAN: {
      ADD_OPTIONS: 'Option hinzufügen',
      EXPLANATION: 'Der Abowechsel erfolgt am Ende der aktuellen Laufzeit.',
      HEADLINE: 'Abo wechseln?'
    },
    DETAILS: {
      ACTIVATE_BUTTON: {
        LABEL: 'Abo aktivieren'
      },
      ACTIVE_CASE: {
        MANAGE_BUTTON: 'Abo verwalten',
        RENEWAL_INFO: 'Ihr Abo wird am {{date}} automatisch zum Preis von {{price}} verlängert.'
      },
      CANCELED: {
        EXPIRED_MAIN: 'Ihr Abonnement ist abgelaufen. Reaktivieren Sie dieses, um Ihren Tracker orten zu können.',
        EXPIRED_SEC: 'Abgelaufen',
        UNCANCEL_BUTTON_LABEL: 'Automatische Verlängerung des Abos aktivieren',
        WILL_EXPIRE_DAYS: 'Läuft in {{count}} Tag ab',
        WILL_EXPIRE_DAYS_plural: 'Läuft in {{count}} Tagen ab',
        WILL_EXPIRE_MAIN: 'Die automatische Verlängerung des Abos ist aufgehoben. Es läuft am {{date}} ab.'
      },
      CANCEL_RESILLIATION: 'Abbrechen der Stornierungsanfrage',
      NEW_CASE: {
        INFO_TEXT: 'Wir sind auf ein Problem mit Ihrer Zahlung gestoßen. Bitte versuchen Sie es erneut oder ändern Sie Ihre Zahlungsdaten.',
        PAY_BUTTON: 'Zahlen und aktivieren'
      },
      NO_SUB: {
        INFO_TEXT: 'Aktivieren Sie das Abo, um mit der Benutzung Ihres Trackers zu beginnen.'
      },
      RESILLIATION_ASKED: 'Stornierung beantragt',
      SUPPORT_TEXT: 'Haben Sie Schwierigkeiten, Ihr Tracker zu aktivieren? Wenden Sie sich an unseren <1>Kundenservice</1>.'
    },
    OFFERS: {
      SAVING_PER_YEAR: 'Sparen Sie {{amount}} pro Jahr'
    },
    OFFERS_TEXT: {
      MOST_POPULAR: 'Das Beliebteste',
      ONE_MONTH: {
        INFO: 'Mindestverpflichtung von 3 Monaten',
        TITLE: 'Formel 1 Monat'
      },
      ONE_YEAR: {
        INFO: '15 Tage Probezeit zusätzlich: 30 Tage insgesamt.',
        TITLE: 'Formel 1 Jahr'
      },
      THREE_YEAR: {
        INFO: '1 Jahr zusätzliche Herstellergarantie: insgesamt 3 Jahre',
        INFO2: '3-year manufacturer\'s warranty (instead of two).',
        TITLE: '3-Jahres-Formel'
      }
    },
    OVERVIEW: {
      OPTIONS: 'Details zu den Optionen',
      REG_DETAILS: 'Details zum Tracker',
      REPLACE_TRACKER_BUTTON: {
        LABEL: 'Tracker ersetzen'
      },
      SUB_DETAILS: 'Details zum Abo'
    },
    PLAN_NAMES: {
      FALLBACK: 'Abo',
      ONE_MONTH: 'Monatliches Abonnement',
      ONE_YEAR: 'Prepaid-Abonnement (1 Jahr)',
      THREE_YEARS: 'Prepaid-Abonnement (3 Jahre)',
      TWO_YEARS: '2-Jahresabo'
    },
    STATUS: {
      ACTIVE: 'Abonniert',
      CANCELED: 'Gekündigt',
      INACTIVE: 'Nicht Abonniert',
      NEW: 'Aktiv',
      PENDING: 'Warte'
    },
    TRACKER_DETAILS: {
      REGISTRATION_DATE: 'Datum der Aktivierung',
      WARRANTY: 'Standardgarantie'
    }
  },
  superLive: {
    ACTIVE_TEXT: 'Der Super-Live-Modus ist aktiv.',
    HEADLINE: 'Super-Live-Modus',
    MESSAGES: {
      SUCCESS_ACTIVATED: 'Der Super-Live-Modus wurde aktiviert – 5 Minuten lang alle {{frequency}} Sekunden ein Standort.'
    },
    TIME: 'Ein Standort alle {{frequency}} Sekunden'
  },
  support: {
    FORM: {
      MESSAGE: {
        LABEL: 'Ihre Nachricht*',
        PLACEHOLDER: ''
      },
      PROBLEM: {
        AVAILABLE_OPTIONS: 'Verfügbare Optionen',
        LABEL: 'Art des Problems*'
      },
      SUBJECT: {
        LABEL: 'Betreff Ihrer Anfrage*',
        PLACEHOLDER: ''
      },
      TRACKER: {
        LABEL: 'Tracker, auf den sich Ihre Anfrage bezieht',
        PLACEHOLDER: 'Wählen Sie den Tracker aus'
      }
    },
    HEADLINE: 'Support',
    HELP_CENTER: 'Hilfe-Center',
    HELP_TEXT: 'Brauchen Sie Hilfe? Besuchen Sie unser Kundencenter, um die Antworten auf Ihre Fragen zu finden. Sie können uns auch mithilfe des untenstehenden Formulars kontaktieren; unser Team antwortet an Werktagen innerhalb von 24 Stunden.',
    MAIN_TEXT: 'Unser Hilfezentrum enthält alle Artikel, die Ihre Fragen beantworten können.',
    MESSAGES: {
      SUBMIT_ERROR: 'Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.',
      SUBMIT_SUCCESS: 'Nachricht erfolgreich versendet'
    },
    PROBLEM_TYPES: {
      CHARGE: 'Mein Tracker wird nicht normal aufgeladen.',
      DOWNLOAD_APP: 'Ich kann die App nicht herunterladen.',
      GPS_INVALID: 'Mein GPS-Signal wird als ungültig angezeigt.',
      GPS_PRECISION: 'Der GPS-Standort meines Trackers ist nicht korrekt.',
      LEDS_FIXED: 'Beide LED Lichter meines Trackers leuchten konstant.',
      NO_GEOFENCE_ALERTS: 'Ich erhalte Fehlalarme über das Betreten oder Verlassen von Zonen.',
      NO_NOTIFICATIONS: 'Ich erhalte keine Benachrichtigungen.',
      OTHER: 'Anderes',
      SIGN_IN: 'Ich kann mich nicht in meinem persönlichen Bereich anmelden.',
      SUBSCRIPTION: 'Ich habe ein Problem mit meinem Abonnement.',
      TRACKERS_PARAMS: 'Ich kann meinen Tracker nicht konfigurieren.',
      TRACKER_NOT_CONNECTED: 'Mein Tracker wird als nicht verbunden angezeigt.'
    },
    SUBMITTED_TICKET: 'Wir haben Ihre Nachricht erhalten, vielen Dank.\nSie haben eine Bestätigung per E-Mail geschickt bekommen (bitte sehen Sie auch in Ihrem Spam-Ordner nach).',
    SUB_TEXT: 'Sollten Ihnen diese Erklärungen nicht ausreichen, können Sie sich auch an einen Mitarbeiter unseres Serviceteams wenden, der Ihnen innerhalb von 24 Arbeitsstunden antworten wird.',
    TITLE: 'Brauchen Sie Hilfe?',
    URGENT_NUMBER: 'Bei dringenden Anliegen erreichen Sie unseren Kundenservice unter \n+33 187 660 083 (montags bis freitags, 10–12 Uhr und 14–17 Uhr).'
  },
  trackerLeftPanel: {
    CALL: 'Anrufen',
    CTR_ONLY_SECONDS: 'Sie können noch {{SECONDS}} Sekunde(n) in diesem Monat telefonieren.',
    CTR_WITH_MINUTES: 'Sie können noch {{MINUTES}} Minute(n) und {{SECONDS}} Sekunde(n) in diesem Monat telefonieren.',
    FLASH: 'Blitz',
    GOOD_GPS_ACCURACY: 'Hohe GPS-Genauigkeit',
    LAST_POSITION: 'Letzter bekannter Standort:',
    MEDIUM_GPS_ACCURACY: 'Mittlere GPS-Genauigkeit',
    OFFLINE: 'Tracker-Verbindung getrennt',
    POOR_GPS_ACCURACY: 'Geringe GPS-Genauigkeit',
    RING: 'Anklingeln',
    SMS_AVAILABLE: 'SMS verfügbar : {{SMS_count}}',
    VIBRATE: 'Vibration'
  },
  trackerSettings: {
    BUTTONS: {
      LABELS: {
        BUTTON: 'Schaltfläche'
      },
      PLACEHOLDER_BUTTON: 'Geben Sie die Nachricht ein, die über die Taste {{button_number}} versandt werden soll',
      TEXT: 'Konfigurieren Sie die Nachrichten, die jeder Taste zugewiesen werden. Diese Meldung erhalten Sie, wenn eine entsprechende Taste gedrückt wird.'
    },
    CONTACTS: {
      ADD_EMAIL_BUTTON: 'E-Mail-Adresse hinzufügen',
      ADD_PHONE_BUTTON: 'Mobilfunknummer hinzufügen',
      EMAILS_LABEL: 'E-Mail-Adressen für die E-Mail-Benachrichtungen',
      MAIL: {
        PLACEHOLDER: 'ihre@email.com'
      },
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten, bitte versuchen Sie es erneut.',
        UPDATE_SUCCESS: 'Kontakte aktualisiert'
      },
      NUMBERS_LABEL: 'Mobilfunknummern für die SMS-Benachrichtigungen ',
      PHONE: {
        PLACEHOLDER: '+4900000000'
      }
    },
    DISPLAY: {
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten.',
        UPDATE_SUCCESS: 'Einstellungen aktualisiert'
      },
      MODAL: {
        HEADLINE: 'Icon auswählen',
        TEXT: 'Sie können das gewünschte Icon in der untenstehenden Liste auswählen. Es stellt Ihren Tracker auf der Karte dar.'
      },
      TRACKER_ICON: {
        EDIT_TEXT: 'Icon ändern',
        LABEL: 'Icon des Trackers'
      },
      TRACKER_NAME: {
        LABEL: 'Name des Trackers',
        PLACEHOLDER: 'Name, der auf der Karte angezeigt wird'
      },
      TRACKER_TYPE: {
        CHANGE: 'Tracker-Typ ändern',
        MODIFIED_SUCCESS: 'Erfolgreich modifizierter Trackertyp'
      }
    },
    GPS_FREQUENCY: {
      BATTERY_USAGE: 'Durchschnittliche Akkulaufzeit:',
      BATTERY_USAGE_LEVELS: {
        HIGH: 'Hoch',
        LOW: 'Schwach',
        MEDIUM: 'Mittel'
      },
      GEOFENCE_NOTIFICATIONS: 'Durchschnittliche Reaktionszeit der Zonenalarme:',
      HINT: 'Eine schnellere Frequenz reduziert die Akkulaufzeit, verkürzt aber die Reaktionszeit der Alarme beim Betreten und Verlassen von Zonen. Umgekehrt schont eine langsamere Frequenz den Akku, verlängert aber die Reaktionszeit der Alarme beim Betreten und Verlassen von Zonen.',
      TEXT: 'Wählen Sie das Zeitintervall für GPS-Berichte aus.'
    },
    NOTIFICATION_SETTINGS: {
      APP: 'App',
      BATTERY: {
        HINT: 'Es wird eine Benachrichtigung an alle Kontakte gesendet, wenn der Tracker kaum mehr Batterie hat.',
        TITLE: 'Akku'
      },
      BUTTONS: {
        HINT: 'Nach dem Drücken einer Seitentaste wird eine Benachrichtigung an alle Kontakte gesendet. Die für diese Taste festgelegte Nachricht wird mit der Benachrichtigung gesendet.',
        TITLE: 'Seitentasten'
      },
      GEOFENCES: {
        HINT: 'Es wird eine Benachrichtigung an alle Kontakte gesendet, wenn der Tracker eine festgelegte Zone eintritt oder verlässt.',
        TITLE: 'Sicherheitszonen'
      },
      MAIL: 'E-Mail',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten, bitte versuchen Sie es erneut.',
        UPDATE_SUCCESS: 'Die Benachrichtigungseinstellungen wurden aktualisiert.'
      },
      SMS: 'SMS',
      SOS: {
        HINT: 'Nach dem Drücken der SOS-Taste wird eine Benachrichtigung an alle Kontakte gesendet.',
        TITLE: 'SOS Anruf'
      },
      WARNING: {
        SMS: {
          LINK: 'Klicken Sie hier, um sie zu aktivieren.',
          TEXT: 'Achtung! Wenn Sie Alarme per SMS erhalten möchten, müssen Sie die entsprechende Option aktivieren.'
        }
      }
    },
    SECTION_TITLES: {
      BUTTONS: 'Tasten',
      CONTACTS: 'Kontakte für die Benachrichtigungen',
      DISPLAY: 'Allgemein',
      GPS_FREQUENCY: 'Zeitintervall für GPS-Berichte',
      NOTIFICATION_SETTINGS: 'Art der Benachrichtigung für jeden Alarm',
      SOS: 'SOS-Nummer',
      TRAINING: 'Telefonfunktion'
    },
    TRAINING_SOS: {
      DIRECT_CALL: 'Diese Nummer anrufen, wenn die SOS-Taste gedrückt wird',
      INPUT_PLACEHOLDER: '+4900000000',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten, bitte versuchen Sie es erneut.',
        UPDATE_SUCCESS: 'Mobilfunknummer aktualisiert'
      },
      SOS_TEXT: 'Mobilfunknummer, die im Falle eines SOS-Alarms angerufen wird',
      TRAINING_TEXT: 'Geben Sie die Mobilfunknummer an, die der Tracker standardmäßig anruft, wenn die Telefonfunktion in der App benutzt wird. Diese Nummer kann bei jeder Anrufanfrage in der App bearbeitet werden.'
    }
  },
  trackers: {
    ADD_TRACKER_BUTTON: {
      LABEL: 'Tracker hinzufügen'
    },
    EXPIRATION: {
      EXPIRED: 'Das Abo für {{tracker}} ist abgelaufen.',
      WILL_EXPIRE: 'Das Abo für {{tracker}} läuft in {{days}} Tagen ab.'
    },
    LINKS: {
      ACTIVITY: 'Aktivitätsverfolgung',
      GEOFENCES: 'Zonen',
      HISTORY: 'Verlauf',
      SETTINGS: 'Einstellungen',
      SUBSCRIPTION: 'Abo'
    }
  },
  trackersPositionRefresh: {
    MESSAGES: {
      NOT_REFRESHED: 'Ihr Tracker konnte die neuen GPS-Standorte nicht abrufen.',
      REFRESHING: 'Bitte warten, eine Update-Anfrage wird gerade bearbeitet.',
      SUCCESS: 'Die GPS-Standorte der Tracker wurden aktualisiert.'
    }
  },
  transferPage: {
    ADD_TRACKER: 'Ich möchte einen neuen Tracker zu meinem Konto hinzufügen',
    BACK_TO_TRACKERS: 'Zurück zur Karte',
    FIRST_TITLE: 'Was genau möchten Sie machen ?',
    FROM_HEADLINE: 'Tracker, der ersetzt werden soll:',
    HEADLINE: 'Einen Tracker ersetzen',
    IMEI_LABEL: 'IMEI-Nummer',
    INFO: 'Das aktuelle Abo, der GPS-Standortverlauf und die Einstellungen werden nach dem Umtausch auf den neuen Tracker übertragen.',
    MESSAGES: {
      ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten, bitte versuchen Sie es erneut.',
      SUCCESS: 'Neuer Tracker zugewiesen',
      WRONG_TYPE: 'Der Tracker mit dieser IMEI-Nummer entspricht nicht dem Typ Ihres alten Trackers. Bitte wenden Sie sich an unseren Kundenservice.'
    },
    NAME_LABEL: 'Name des Trackers',
    PURCHASE: 'Sie haben noch keinen Weenect-Tracker? <1>Hier können Sie einen kaufen.</1>',
    REPLACE_BUTTON: {
      LABEL: 'Ersetzen'
    },
    REPLACE_TRACKER: 'Ich möchte einen vorhandenen Tracker ersetzen',
    TO_HEADLINE: 'Neuer Tracker:'
  },
  webappDisconnection: {
    BUG: 'Es scheint, dass Ihr Tracker Probleme hat, sich mit dem Netzwerk zu verbinden.',
    MANUAL: 'Sie haben Ihren Tracker ausgeschaltet. Drücken Sie die ON-Taste, um das Gerät wieder einzuschalten.',
    NO_BATTERY: 'Ihr Tracker hat sich ausgeschaltet, weil der Akku leer war.',
    NO_SUB: 'Sie haben kein Abonnement für diesen Tracker. Bitte holen Sie sich eines, indem Sie auf die Website gehen'
  },
  wifiZones: {
    AIRPLANE_TEXT: 'Achtung: Im Flugzeugmodus können Sie Ihren Tracker, solange er sich in der Energiesparzonen befindet, nicht mehr klingeln oder vibrieren lassen  oder seine Position manuell aktualisieren.',
    DEEP_SLEEP_TITLE: 'Flugzeugmodus',
    DISPLAY_BUTTON: 'Zone auf der Karte anzeigen',
    DISPLAY_TITLE: 'Benachrichtigungen und Anzeige',
    IN_AIRPLANE: '- in Flugmodus',
    IN_OUT_TEXT: 'Ein- und Ausgänge der Zone:',
    LAST_POS_IN_WIFI: 'In der Energiesparzonen seit {{date}} ',
    MAIL_NOTIF: 'Mail Benachrichtigungen',
    NOTIF_TEXT: 'Erhalten Sie eine Benachrichtigung über jeden Ein- und Ausstieg aus dem vordefinierten Bereich',
    POPIN: {
      AIRPLANE: {
        BUTTON_VALIDATE: 'Den Flugzeugmodus verlassen',
        CONTENT: 'Sie können nicht mehr mit Ihrem Tracker kommunizieren, solange er sich in der Energiesparzonen befindet. Wenn Sie die volle Funktionalität wiederherstellen möchten, <strong>schalten Sie den Flugzeugmodus aus und nehmen Sie den Tracker aus der Zone heraus. </strong>',
        TITLE: 'Ihr Tracker befindet sich im Flugzeugmodus in der Energiesparzonen {{wifiName}}.'
      },
      BUTTON_CLOSE: 'Es später tun',
      BUTTON_VALIDATE: 'Zone deaktivieren',
      CONTENT: 'In dieser Zone ist die automatische Übertragung der GPS-Positionen Ihres Trackers deaktiviert, Sie können ihn jedoch klingeln lassen, um ihn zu finden.<strong> Sie können auch die Energiesparzonen deaktivieren</strong>.',
      TITLE: 'Ihr Tracker befindet sich in der Energiesparzonen {{wifiName}}.'
    },
    PUSH_NOTIF: 'Push Benachrichtigungen',
    SMS_NOTIF: 'SMS Benachrichtigungen',
    TITLE: 'Energiesparzonen',
    ZONE_ACTIVATION: 'Zonenaktivierung'
  }
}
